<div class="official-website-content">
  <div class="header-title" style="margin-bottom: 80px;">
    <h1><span>博世维修站网络生态系统</span></h1>
    <p>博世提供多维度的维修站网络概念，以品牌为基石，从eXtra增值计划到博世配件优选、博世配件精选、博世配件质选，再到具有强大品牌力的博世车联及博世柴油系统服务网络，满足您不同的发展需求。
    </p>
    <p>
      <img src="assets/official-website/service.png" alt="services">
    </p>
  </div>
  <h1 class="service-cards-title ">全部服务</h1>
  <div class="service-cards-content">
    <div class="service-cards grid grid-cols-3 gap-8">
      <a *ngFor="let service of services" [href]="service.link" class="service-card-item">
        <div class="max-h-[200px] overflow-hidden">
          <img [src]="service.image" alt="{{ service.title }}" class="card-image">
        </div>
        <div class="card-text">
          <p>{{ service.category }}</p>
          <div style="display: flex; align-items: center;">
            <h2>{{ service.title }}</h2><img src="assets/official-website/arrow-right.png" class="arrow-image">
          </div>
        </div>
      </a>
    </div>
  </div>
</div>